<template>
    <div>
        <div v-if="error">
            <slot name="error" :error="error" :info="info" />
        </div>
        <div v-else>
            <slot />
        </div>
    </div>
</template>

<script>
    import { onErrorCaptured, ref } from 'vue';

    export default {
        setup() {
            const error = ref(null);
            const info = ref(null);

            onErrorCaptured((err, vm, infoStr) => {
                error.value = err;
                info.value = infoStr;
                console.error(`Error found in ${infoStr} of component:\n\n${err.stack}`);
                return false; // Prevent the error from propagating further
            });

            return {
                error,
                info,
            };
        },
    };
</script>
